export const ROUTE_NAME_SIGN_IN = 'signInView';
export const ROUTE_NAME_PASSWORD_LOST = 'passwordLost';

export const ROUTE_NAME_FIRST_CONNECTION = 'firstConnection';
export const ROUTE_NAME_CREATE_ACCESS = 'createAccess';
export const ROUTE_NAME_ACCOUNT_RECOVERY_EMAIL_CONFIRMATION = 'accountRecoveryEmailConfirmation';
export const ROUTE_NAME_ACCOUNT_SET_PASSWORD = 'accountSetPassword';

/**
 * Toutes les routes liées à la section principales de l'utilisateur (Customer view)
 */
export const ROUTE_NAME_CUSTOMER_VIEW = 'customerView';
export const ROUTE_NAME_CUSTOMER_HOME_VIEW = 'customerHome';
export const ROUTE_NAME_BOOKING_VIEW = 'bookingView';
export const ROUTE_NAME_BOOKING_FORM_DATED = 'bookingFormDated';
export const ROUTE_NAME_BOOKING_FORM_TEMPLATE = 'bookingFormTemplate';
export const ROUTE_NAME_CUSTOMER_VEHICLE_TRACKING = 'customerVehicleTracking';
export const ROUTE_NAME_CONTACT_US_VIEW = 'contactUs';
export const ROUTE_NAME_SIGNED_OUT_CONTACT_US = 'SignedOutContactUs';

/**
 * Route générique englobant à la fois les routes pour la liste des déplacements et celles pour l'affichage des
 * détails.
 */
export const ROUTE_NAME_CUSTOMER_TRIPS = 'customerTripsOverview';
export const ROUTE_NAME_CUSTOMER_TRIPS_LIST = 'customerTripList';
export const ROUTE_NAME_CUSTOMER_TRIPS_DATED = 'customerTripsDated';
export const ROUTE_NAME_CUSTOMER_TRIPS_TEMPLATE = 'customerTripsTemplate';
export const ROUTE_NAME_CUSTOMER_TRIP_DETAILS_DATED = 'customerTripDetailsDated';
export const ROUTE_NAME_CUSTOMER_TRIP_DETAILS_TEMPLATE = 'customerTripDetailsTemplate';
export const ROUTE_NAME_CUSTOMER_PROFILE = 'customerProfile';
export const ROUTE_NAME_CUSTOMER_CHANGE_PASSWORD = 'changePasswordView';
export const ROUTE_NAME_CUSTOMER_MODIFY_ASSISTIVE_DEVICES = 'modifyAssistiveDevices';
export const ROUTE_NAME_CUSTOMER_MODIFY_INFO = 'modifyCustomerInfo';
export const ROUTE_NAME_CUSTOMER_FAVOURITE_ADDRESSES = 'customerFavouriteAddresses';

/** Section historique */
export const ROUTE_NAME_HISTORY_VIEW = 'HistoryView';
export const ROUTE_NAME_HISTORY_FORM_EMAIL = 'HistoryFormEmail';
export const ROUTE_NAME_HISTORY_TRIP_DETAILS = 'HistoryTripDetails';
/** Page d'erreur 404 */
export const ROUTE_NAME_NOT_FOUND = 'notFound';
/** nom du chemin de base pour toutes les routes liées à la gestion du compte */
export const ROUTE_PATH_ACCOUNT_BASE = 'compte';
export const ROUTE_PATH_CLIENT_BASE = 'client';
